import React from 'react'

function NoteIcon() {
  return (
<svg width="20" height="20" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.6016 0.599609H0.601562V15.5996H8.10156L10.6016 18.0996L13.1016 15.5996H20.6016V0.599609Z" stroke="#E2E3E3" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.6016 8.09961V12.5996" stroke="#E2E3E3" stroke-width="1.2" stroke-linecap="round"/>
<path d="M10.6016 4.59961V5.09961" stroke="#E2E3E3" stroke-width="1.2" stroke-linecap="round"/>
</svg>

  )
}

export default NoteIcon